import config from 'src/config/config';
const { API_BASE_URL } = config;

const DOMAIN_URL = API_BASE_URL;

export const user_service = {
	GET_USER_ACCESS_LIST: DOMAIN_URL + '/api/external/user-role-access',
};

export const external_service = {
	GET_MASTER_PARAMETER: DOMAIN_URL + '/api/external/get-master-parameter',
	GET_MASTER_DATA_SHOP_AND_LINE: DOMAIN_URL + '/api/misc/get-shop-line-data',
	GET_DIGITAL_TWIN_SYNC_DATA: DOMAIN_URL + '/api/misc/start-digital-twin-sync',
	GET_PRESIGNED_URLS_FOR_PART_IMAGES:
		DOMAIN_URL + '/api/misc/get-presigned-url-add',
};

export const access_service = {
	GET_PLANT_LIST: DOMAIN_URL + '/api/misc/get-plant-list',
	GET_SHOP_LIST: DOMAIN_URL + '/api/misc/get-shop-list-admin',
	GET_LINE_LIST: DOMAIN_URL + '/api/misc/get-line-list-admin',
};

export const packaging_strategy_all_endpoints = {
	GET_PACKAGING_STRATERGIES_LIST_BY_SEARCH:
		DOMAIN_URL + '/api/strategy/get-strategies-list-by-search',
	POST_ADD_STRATEGY_EXCEL_UPLOAD:
		DOMAIN_URL + '/api/strategy/upload-logistics-excel',
	POST_REUPLOAD_STRATEGY_EXCEL:
		DOMAIN_URL + '/api/strategy/reupload-logistics-excel ',
	POST_UPDATE_STRATEGY_EXCEL_UPLOAD:
		DOMAIN_URL + '/api/strategy/update-strategies-details-by-id',
	POST_DELETE_STRATEGY_RECORDS:
		DOMAIN_URL + '/api/strategy/delete-strategies-by-id',
	POST_STRATEGY_ADD_FEEDBACK: DOMAIN_URL + '/api/strategy/add-feedback',
	POST_STRATEGY_ADD_APPROVAL_STATUS:
		DOMAIN_URL + '/api/strategy/upload-logistics-status',
	POST_ADD_NEW_STRATEGY: DOMAIN_URL + '/api/strategy/add-logistics-details',
	GET_PRESIGNED_IMAGES: DOMAIN_URL + '/api/misc/get-presigned-url',
	POST_DRAFT_NEW_STRATEGY:
		DOMAIN_URL + '/api/strategy/add-draft-logistics-details',
};

export const mis_reports_all_endpoints = {
	GET_MONTHLY_KPI_DATA: DOMAIN_URL + '/api/dashboard/get-monthly-kpi-data',
	GET_MONTHLY_USER_WISE_DATA:
		DOMAIN_URL + '/api/dashboard/get-monthly-mis-user-wise-data',
	GET_MONTHLY_PLANT_WISE_DATA:
		DOMAIN_URL + '/api/dashboard/get-monthly-plant-wise-data',
	GET_MONHTLY_OTHER_DATA: DOMAIN_URL + '/api/dashboard/get-monthly-other-data',

	GET_YEARLY_MONTHWISE_INCLUDING_IN_PART_COST_SUMMARY_DATA_BY_PLANT:
		DOMAIN_URL +
		'/api/dashboard/get-yearly-monthwise-including-in-part-cost-summary-data-by-plant',
	GET_YEARLY_MONTHWISE_PLANWISE_VS_STRATEGY_SUMMARY_DATA_BY_PLANT:
		DOMAIN_URL +
		'/api/dashboard/get-yearly-monthwise-planwise-vs-strategy-summary-data-by-plant',
	GET_MONTHLY_SUPPLIER_WISE_PROGRESS_DATA_BY_PLANT:
		DOMAIN_URL +
		'/api/dashboard/get-monthly-supplier-wise-progress-list-by-plants',
	GET_YEARLY_MONTHWISE_INCOTERM_DATA_BY_PLANTS:
		DOMAIN_URL + '/api/dashboard/get-yearly-monthwise-incoterm-data-by-plants',
	GET_YEARLY_MONTHWISE_SUMMARY_DATA_BY_USERS:
		DOMAIN_URL + '/api/dashboard/get-yearly-monthwise-summary-data-by-users',
	GET_ACTIVE_USERS_LIST_BY_PLANT_IDS:
		DOMAIN_URL + '/api/dashboard/get-active-users-list-by-plant-ids',

	GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_SHEETS_DATA:
		DOMAIN_URL +
		'/api/dashboard/get-plant-wise-logistics-recommendations-sheets-data',
	GET_PLANT_WISE_LOGISTICS_RETURNABLE_PERCENTAGE_DATA:
		DOMAIN_URL +
		'/api/dashboard/get-plant-wise-logistics-returnable-percentage-data',
	GET_PLANT_WISE_LOGISTICS_RETURNABLE_EXPENDABLE_COST_DATA:
		DOMAIN_URL +
		'/api/dashboard/get-plant-wise-logistics-returnable-expendable-cost-data',
	GET_PLANT_WISE_INCO_TERM_COST_DATA:
		DOMAIN_URL + '/api/dashboard/get-plant-wise-inco-term-cost-data',
	GET_PLANT_WISE_LOGISTICS_COST_DATA:
		DOMAIN_URL + '/api/dashboard/get-plant-wise-logistics-cost-data',
	GET_PLANT_WISE_LOGISTICS_ANNUAL_COST_DATA:
		DOMAIN_URL + '/api/dashboard/get-logistics-annual-cost-data',
	GET_PLANT_WISE_LOGISTICS_ANNUAL_RECOMMENDATIONS_DATA:
		DOMAIN_URL + '/api/dashboard/get-logistics-annual-recommendation-data',
	GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_COUNT_AND_COST_DATA:
		DOMAIN_URL +
		'/api/dashboard/get-user-wise-logistics-recommendation-count-and-cost-data',
	GET_MONTHLY_STRATEGY_DETAILS_LIST:
		DOMAIN_URL + '/api/dashboard/get-monthly-strategy-details-list',
	GET_MONTHLY_USER_ROLE_WISE_PROGRESS_DATA_BY_PLANT:
		DOMAIN_URL +
		'/api/dashboard/get-monthly-user-role-wise-progress-list-by-plants',
	GET_MODEL_WISE_COSTING_DATA:
		DOMAIN_URL + '/api/dashboard/get-monthly-model-wise-data-by-plant',
};

export const dashboard_all_endpoints = {
	GET_PLANT_WISE_SUMMARY_DATA_FOR_DASHBOARD:
		DOMAIN_URL + '/api/dashboard/get-plant-wise-summary-data-for-dashboard',
};

export const feedbacks_module_apis = {
	GET_FEEDBACKS_LIST_BY_STRATEGY_ID:
		DOMAIN_URL + '/api/strategy/get-feedbacks-list-by-strategy-id',
};

export const packaging_strategy_view_all_endpoints = {
	GET_PACKAGING_STRATERGIES_VIEW_BY_ID:
		DOMAIN_URL + '/api/strategy/get-strategies-details-by-id',
	GET_DRAFT_PACKAGING_STRATERGIES_VIEW_BY_ID:
		DOMAIN_URL + '/api/strategy/get-draft-strategies-details-by-id',
};

export const user_management_service = {
	GET_USER_MANAGEMENT_LIST: DOMAIN_URL + '/api/user/get-user-list',
	ADD_NEW_USER: DOMAIN_URL + '/api/user/add-user',
	UPDATE_USER: DOMAIN_URL + '/api/user/update-user',
	DELETE_USER: DOMAIN_URL + '/api/user/delete-user',
	GET_USER_ROLE_DETAILS: DOMAIN_URL + '/api/user/get-user-role-details',
	GET_USER_ROLE_DETAILS_BY_ROLE: DOMAIN_URL + '/api/user/get-users-by-role',
	GET_COMMODITY_TYPE_ROLE_DETAILS:
		DOMAIN_URL + '/api/user/get-commodity-type-details',
};

export const dashboard_service = {
	GET_DASHBOARD_KPI: DOMAIN_URL + '/api/dashboard/get-dashboard-data',
	GET_LINE_WISE_VIN: DOMAIN_URL + '/api/dashboard/get-line-wise-vin-data',
};

export const dashboard_alerts = {
	GET_ALERTS_LIST: DOMAIN_URL + '/api/strategy/get-alerts-list',
	GET_ALERTS_LIST_FOR_NOTIFICATION:
		DOMAIN_URL + '/api/strategy/get-alerts-list-for-notification',
};

export const byPassUrlsForResponseHandlingToaster = [
	user_service.GET_USER_ACCESS_LIST,
	external_service.GET_MASTER_PARAMETER,
	external_service.GET_MASTER_DATA_SHOP_AND_LINE,
	dashboard_alerts.GET_ALERTS_LIST,
	dashboard_alerts.GET_ALERTS_LIST_FOR_NOTIFICATION,
	access_service.GET_PLANT_LIST,
	access_service.GET_SHOP_LIST,
	access_service.GET_LINE_LIST,
	packaging_strategy_all_endpoints.GET_PACKAGING_STRATERGIES_LIST_BY_SEARCH,
	packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
	feedbacks_module_apis.GET_FEEDBACKS_LIST_BY_STRATEGY_ID,
	user_management_service.GET_USER_MANAGEMENT_LIST,
	dashboard_service.GET_DASHBOARD_KPI,
	dashboard_service.GET_LINE_WISE_VIN,
	dashboard_alerts.GET_ALERTS,
	dashboard_alerts.GET_NEW_ALERTS,
	dashboard_alerts.UPDATE_ALERTS_STATUS,
	mis_reports_all_endpoints.GET_MONTHLY_KPI_DATA,
	mis_reports_all_endpoints.GET_MONTHLY_USER_WISE_DATA,
	mis_reports_all_endpoints.GET_MONTHLY_PLANT_WISE_DATA,
	mis_reports_all_endpoints.GET_MONHTLY_OTHER_DATA,
	mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_INCLUDING_IN_PART_COST_SUMMARY_DATA_BY_PLANT,
	mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_PLANWISE_VS_STRATEGY_SUMMARY_DATA_BY_PLANT,
	mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_INCOTERM_DATA_BY_PLANTS,
	mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_SUMMARY_DATA_BY_USERS,
	mis_reports_all_endpoints.GET_ACTIVE_USERS_LIST_BY_PLANT_IDS,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_SHEETS_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RETURNABLE_PERCENTAGE_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RETURNABLE_EXPENDABLE_COST_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_INCO_TERM_COST_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_COST_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_ANNUAL_COST_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_ANNUAL_RECOMMENDATIONS_DATA,
	mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_COUNT_AND_COST_DATA,
	dashboard_all_endpoints.GET_PLANT_WISE_SUMMARY_DATA_FOR_DASHBOARD,
	user_management_service.GET_USER_ROLE_DETAILS,
	user_management_service.GET_USER_ROLE_DETAILS_BY_ROLE,
	user_management_service.GET_COMMODITY_TYPE_ROLE_DETAILS,
];
